import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { LienParental } from "app/models/lien-parental";

@Injectable()
export class LienParentalService {
  private url = `/api/lien/parental`;
  constructor(private http: HttpClient) { }


  public find(): Observable<[LienParental]> {
    const params = new HttpParams()
      .set('size', 'page')
      .set('size', '50')
      .set('sortName', 'id')
      .set('sortType', 'DESC');
     return this.http.get<[LienParental]>(this.url, { params: params });
   }

   create(item: LienParental) {
     return this.http.post(this.url, item)
       .map(
         (data) => {
           console.log(data);
         }
       );
   }

   delete(item: LienParental) {
     return this.http.delete(`${this.url}/${item.id}`)
       .map(
         (data) => {
           console.log(data);
         }
       );
   }
   update(item: LienParental) {
     return this.http.put(`${this.url}/${item.id}`, item)
       .map(
         (data) => {
           console.log(data);
         }
       );
   }
 }



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/lien-parental.service.ts